// before 20-5-2026


// import {
//   Autocomplete,
//   TextField,
//   FormControl,
//   Alert,
//   Checkbox,
//   FormControlLabel,
//   ListItemText,
//   Snackbar,
//   Box,
//   Paper,
//   Typography,
//   Button,
//   Avatar,
//   Divider,
//   Grid,
//   Tooltip,
//   IconButton,
//   useTheme,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Chip,
// } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import { GetAll_stage_Data } from '../../Redux/Actions/Stage_Action';
// import { GetAllchannalData } from '../../Redux/Actions/ChannalActions';
// import { GetCommunicationwayData } from '../../Redux/Actions/CommunicationWay_Action';
// import { GetAllCampainData } from '../../Redux/Actions/Campaign_Actions';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetallProjectsdata } from '../../Redux/Actions/Projects_Action';
// import { Get_All_Sales_Action } from '../../Redux/Actions/SalesAction';
// import { useNavigate } from 'react-router-dom';
// import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
// import CopyToClipboard from 'react-copy-to-clipboard';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import { Notify } from '../../Utility/Notify';
// import baseurl, { db_url } from '../../Api/BaseUrl';
// import WebhookIcon from '@mui/icons-material/Webhook';
// import SettingsIcon from '@mui/icons-material/Settings';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
// import LinkIcon from '@mui/icons-material/Link';

// export const IntegrationWebhook = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const dispatch = useDispatch();

//   // states for autocomplete
//   const [selectedProject, setSelectedProject] = useState(null);
//   const [selectedSales, setSelectedSales] = useState(null);
//   const [selectedStage, setSelectedStage] = useState(null);
//   const [selectedChannal, setSelectedChannal] = useState(null);
//   const [selectedCommunicationway, setSelectedCommunicationway] = useState(null);
//   const [selectedCampaign, setSelectedCampaign] = useState(null);

//   const [projectInputValue, setProjectInputValue] = useState('');
//   const [salesInputValue, setSalesInputValue] = useState('');
//   const [stageInputValue, setStageInputValue] = useState('');
//   const [channalInputValue, setChannalInputValue] = useState('');
//   const [communicationwayInputValue, setCommunicationwayInputValue] = useState('');
//   const [campaignInputValue, setCampaignInputValue] = useState('');

//   const [project, setproject] = useState('');
//   const [salesdata, setsalesdata] = useState('');
//   const [stage, setstage] = useState('');
//   const [Channal, setchannal] = useState('');
//   const [Communicationway, setcommunicationwat] = useState('');
//   const [campaignid, setcampaignid] = useState('');
  
//   // Existing optional fields
//   const [includeWhatsapp, setIncludeWhatsapp] = useState(false);
//   const [includePhone2, setIncludePhone2] = useState(false);
//   const [includeJobDesc, setIncludeJobDesc] = useState(false);
  
//   // Questions states
//   const [includeQuestion1, setIncludeQuestion1] = useState(false);
//   const [includeQuestion2, setIncludeQuestion2] = useState(false);
//   const [includeQuestion3, setIncludeQuestion3] = useState(false);
//   const [includeQuestion4, setIncludeQuestion4] = useState(false);
//   const [includeQuestion5, setIncludeQuestion5] = useState(false);
  
//   // Question texts only (answers will come from form later)
//   const [question1_text, setQuestion1_text] = useState('');
//   const [question2_text, setQuestion2_text] = useState('');
//   const [question3_text, setQuestion3_text] = useState('');
//   const [question4_text, setQuestion4_text] = useState('');
//   const [question5_text, setQuestion5_text] = useState('');
  
//   // Campaign Redirect Link state
//   const [campaignRedirectLink, setCampaignRedirectLink] = useState('');
  
//   const [copied, setCopied] = useState(false);

//   // دوال الـ autocomplete
//   const handleProjectChange = (event, newValue) => {
//     setSelectedProject(newValue);
//     setproject(newValue ? newValue._id : '');
//   };

//   const handleSalesChange = (event, newValue) => {
//     setSelectedSales(newValue);
//     setsalesdata(newValue ? newValue._id : '');
//   };

//   const handleStageChange = (event, newValue) => {
//     setSelectedStage(newValue);
//     setstage(newValue ? newValue._id : '');
//   };

//   const handleChannalChange = (event, newValue) => {
//     setSelectedChannal(newValue);
//     setchannal(newValue ? newValue._id : '');
//   };

//   const handleCommunicationwayChange = (event, newValue) => {
//     setSelectedCommunicationway(newValue);
//     setcommunicationwat(newValue ? newValue._id : '');
//   };

//   const handleCampaignChange = (event, newValue) => {
//     setSelectedCampaign(newValue);
//     setcampaignid(newValue ? newValue._id : '');
//   };

//   useEffect(() => {
//     const getstages = async () => {
//       await dispatch(GetAll_stage_Data());
//       await dispatch(GetAllchannalData());
//       await dispatch(GetCommunicationwayData());
//       await dispatch(GetAllCampainData());
//     };
//     getstages();
//   }, [dispatch]);

//   const resgetallstages = useSelector((state) => state.Allstages.stage);
//   const resgetallchannal = useSelector((state) => state.AllChannalRoot.channal);
//   const resgetallcommunicationway = useSelector(
//     (state) => state.AllCommunicationway.communicationway,
//   );
//   const resgetcampaindata = useSelector((state) => state.AllCampaign.campaign);

//   let res_getallstages_array = Array.isArray(resgetallstages?.data) ? resgetallstages.data : [];
//   let res_getallchannal_array = Array.isArray(resgetallchannal?.data) ? resgetallchannal.data : [];
//   let res_getallcommunicationway_array = Array.isArray(resgetallcommunicationway?.data)
//     ? resgetallcommunicationway.data
//     : [];
//   let res_get_campaign_data_array = Array.isArray(resgetcampaindata?.data)
//     ? resgetcampaindata.data
//     : [];

//   const ressales = useSelector((state) => state.AllSales.sales);

//   let salesData = (Array.isArray(ressales?.data) ? ressales.data : [])
//     .filter(
//       (sale) =>
//         ![
//           'Default',
//           'Default M',
//           'Default T',
//           'Default S',
//           'Deveolper',
//           'Developer',
//           'Dev',
//         ].includes(sale.name),
//     )
//     .sort((a, b) => {
//       if (a.name === 'No Sales') return -1;
//       if (b.name === 'No Sales') return 1;
//       return 0;
//     });

//   useEffect(() => {
//     const getprojects = async () => {
//       await dispatch(GetallProjectsdata());
//       await dispatch(Get_All_Sales_Action());
//     };
//     getprojects();
//   }, []);

//   const resProjects = useSelector((state) => state.AllProjects.Projects);

//   let Allprojects = [];
//   if (resProjects && resProjects.data) {
//     Allprojects = resProjects.data;
//   } else {
//     Allprojects = [];
//   }

//   let user = '';
//   if (localStorage.getItem('user') != null) {
//     user = JSON.parse(localStorage.getItem('user'));
//   }

//   const [selectedValuesintegration, setselectedValuesintegration] = useState({
//     addedby: user.data?._id || '',
//   });

//   const [urlcreated, seturlcreated] = useState('');
//   const [generate, setgenerate] = useState(true);

//   const navigate = useNavigate();

//   // ✅ Updated useEffect with questions (text only) and campaign redirect link
//   useEffect(() => {
//     const params = {
//       addedby: user.data?._id || '',
//       stage,
//       Channal,
//       project,
//       salesdata,
//       Communicationway,
//       campaignid,
//       includePhone2: includePhone2 ? 'true' : 'false',
//       includeWhatsapp: includeWhatsapp ? 'true' : 'false',
//       includeJobDesc: includeJobDesc ? 'true' : 'false',
//       // Questions flags
//       includeQuestion1: includeQuestion1 ? 'true' : 'false',
//       includeQuestion2: includeQuestion2 ? 'true' : 'false',
//       includeQuestion3: includeQuestion3 ? 'true' : 'false',
//       includeQuestion4: includeQuestion4 ? 'true' : 'false',
//       includeQuestion5: includeQuestion5 ? 'true' : 'false',
//       // ✅ Question texts only (answers will be in body)
//       ...(includeQuestion1 && question1_text && { question1_text }),
//       ...(includeQuestion2 && question2_text && { question2_text }),
//       ...(includeQuestion3 && question3_text && { question3_text }),
//       ...(includeQuestion4 && question4_text && { question4_text }),
//       ...(includeQuestion5 && question5_text && { question5_text }),
//       // Campaign redirect link
//       ...(campaignRedirectLink && { campaignRedirectLink }),
//     };

//     // Remove undefined values
//     Object.keys(params).forEach(key => 
//       params[key] === undefined && delete params[key]
//     );

//     setselectedValuesintegration(params);
//   }, [
//     stage,
//     Channal,
//     project,
//     salesdata,
//     Communicationway,
//     campaignid,
//     includePhone2,
//     includeWhatsapp,
//     includeJobDesc,
//     includeQuestion1,
//     includeQuestion2,
//     includeQuestion3,
//     includeQuestion4,
//     includeQuestion5,
//     question1_text,
//     question2_text,
//     question3_text,
//     question4_text,
//     question5_text,
//     campaignRedirectLink,
//     user.data?._id,
//   ]);

//   const generateUrl = () => {
//     // Validate required fields
//     if (project === '') {
//       Notify('error', 'Project is required', 'error');
//       return;
//     } else if (salesdata === '') {
//       Notify('error', 'Sales is required', 'error');
//       return;
//     } else if (Channal === '') {
//       Notify('error', 'Channel is required', 'error');
//       return;
//     } else if (Communicationway === '') {
//       Notify('error', 'Communication way is required', 'error');
//       return;
//     } else if (stage === '') {
//       Notify('error', 'Stage is required', 'error');
//       return;
//     } else if (campaignid === '') {
//       Notify('error', 'Campaign is required', 'error');
//       return;
//     } else if (!user.data?._id) {
//       Notify('error', 'User is required', 'error');
//       return;
//     }

//     // ✅ Validate question texts if included
//     if (includeQuestion1 && !question1_text) {
//       Notify('error', 'Question 1 text is required', 'error');
//       return;
//     }
//     if (includeQuestion2 && !question2_text) {
//       Notify('error', 'Question 2 text is required', 'error');
//       return;
//     }
//     if (includeQuestion3 && !question3_text) {
//       Notify('error', 'Question 3 text is required', 'error');
//       return;
//     }
//     if (includeQuestion4 && !question4_text) {
//       Notify('error', 'Question 4 text is required', 'error');
//       return;
//     }
//     if (includeQuestion5 && !question5_text) {
//       Notify('error', 'Question 5 text is required', 'error');
//       return;
//     }

//     setgenerate(true);
//     const baseUrl = '';
//     const queryParams = new URLSearchParams(selectedValuesintegration).toString();

//     const newUrl = `${baseUrl}?${queryParams}`;
//     seturlcreated(`${db_url}api/v1/users/create-with-params` + newUrl);
//     setgenerate(false);
//     setCopied(false);
//   };

//   const handleCopy = () => {
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   return (
//     <Paper
//       elevation={3}
//       sx={{
//         p: { xs: 2, sm: 3, md: 4 },
//         borderRadius: 4,
//         backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//         border: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
//       }}
//     >
//       {/* Header */}
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
//         <Avatar sx={{ bgcolor: '#102dff', width: 48, height: 48 }}>
//           <WebhookIcon />
//         </Avatar>
//         <Box>
//           <Typography variant="h5" sx={{ fontWeight: '700', color: '#102dff' }}>
//             Webhook Integration
//           </Typography>
//           <Typography variant="body2" sx={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//             Configure your webhook endpoint settings
//           </Typography>
//         </Box>
//       </Box>

//       <Divider sx={{ mb: 4, backgroundColor: mode === 'dark' ? '#333' : '#e0e0e0' }} />

//       {/* Required Fields Section */}
//       <Box sx={{ mb: 3 }}>
//         <Typography
//           variant="subtitle1"
//           sx={{
//             fontWeight: '600',
//             color: '#102dff',
//             mb: 2,
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1,
//           }}
//         >
//           <SettingsIcon sx={{ fontSize: 20 }} />
//           Required Configuration
//         </Typography>
//       </Box>

//       <Grid container spacing={3}>
//         {/* Project Id */}
//         <Grid item xs={12} md={6}>
//           <Autocomplete
//             options={Allprojects || []}
//             getOptionLabel={(option) => option.name || ''}
//             value={selectedProject}
//             onChange={handleProjectChange}
//             inputValue={projectInputValue}
//             onInputChange={(event, newInputValue) => {
//               setProjectInputValue(newInputValue);
//             }}
//             renderInput={(params) => (
//               <TextField {...params} label="Project *" variant="outlined" required size="small" />
//             )}
//             renderOption={(props, option) => (
//               <li {...props} key={option._id}>
//                 {option.name}
//               </li>
//             )}
//           />
//         </Grid>

//         {/* Sales Id */}
//         <Grid item xs={12} md={6}>
//           <Autocomplete
//             options={salesData || []}
//             getOptionLabel={(option) => option.name || ''}
//             value={selectedSales}
//             onChange={handleSalesChange}
//             inputValue={salesInputValue}
//             onInputChange={(event, newInputValue) => {
//               setSalesInputValue(newInputValue);
//             }}
//             renderInput={(params) => (
//               <TextField {...params} label="Sales *" variant="outlined" required size="small" />
//             )}
//             renderOption={(props, option) => (
//               <li {...props} key={option._id}>
//                 <Box>
//                   <Typography variant="body2">{option.name}</Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     {option?.userlog?.role || 'No role'}
//                   </Typography>
//                 </Box>
//               </li>
//             )}
//           />
//         </Grid>

//         {/* Stage Id */}
//         <Grid item xs={12} md={6}>
//           <Autocomplete
//             options={res_getallstages_array || []}
//             getOptionLabel={(option) => option.name || ''}
//             value={selectedStage}
//             onChange={handleStageChange}
//             inputValue={stageInputValue}
//             onInputChange={(event, newInputValue) => {
//               setStageInputValue(newInputValue);
//             }}
//             renderInput={(params) => (
//               <TextField {...params} label="Stage *" variant="outlined" required size="small" />
//             )}
//             renderOption={(props, option) => (
//               <li {...props} key={option._id}>
//                 {option.name}
//               </li>
//             )}
//           />
//         </Grid>

//         {/* Channel Id */}
//         <Grid item xs={12} md={6}>
//           <Autocomplete
//             options={res_getallchannal_array || []}
//             getOptionLabel={(option) => option.name || ''}
//             value={selectedChannal}
//             onChange={handleChannalChange}
//             inputValue={channalInputValue}
//             onInputChange={(event, newInputValue) => {
//               setChannalInputValue(newInputValue);
//             }}
//             renderInput={(params) => (
//               <TextField {...params} label="Channel *" variant="outlined" required size="small" />
//             )}
//             renderOption={(props, option) => (
//               <li {...props} key={option._id}>
//                 {option.name}
//               </li>
//             )}
//           />
//         </Grid>

//         {/* Communication Way Id */}
//         <Grid item xs={12} md={6}>
//           <Autocomplete
//             options={res_getallcommunicationway_array || []}
//             getOptionLabel={(option) => option.name || ''}
//             value={selectedCommunicationway}
//             onChange={handleCommunicationwayChange}
//             inputValue={communicationwayInputValue}
//             onInputChange={(event, newInputValue) => {
//               setCommunicationwayInputValue(newInputValue);
//             }}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 label="Communication Way *"
//                 variant="outlined"
//                 required
//                 size="small"
//               />
//             )}
//             renderOption={(props, option) => (
//               <li {...props} key={option._id}>
//                 {option.name}
//               </li>
//             )}
//           />
//         </Grid>

//         {/* Campaign Id */}
//         <Grid item xs={12} md={6}>
//           <Autocomplete
//             options={res_get_campaign_data_array || []}
//             getOptionLabel={(option) => option.CampainName || ''}
//             value={selectedCampaign}
//             onChange={handleCampaignChange}
//             inputValue={campaignInputValue}
//             onInputChange={(event, newInputValue) => {
//               setCampaignInputValue(newInputValue);
//             }}
//             renderInput={(params) => (
//               <TextField {...params} label="Campaign *" variant="outlined" required size="small" />
//             )}
//             renderOption={(props, option) => (
//               <li {...props} key={option._id}>
//                 {option.CampainName}
//               </li>
//             )}
//           />
//         </Grid>
//       </Grid>

//       {/* Optional Fields Section - Basic */}
//       <Box sx={{ mt: 4, mb: 3 }}>
//         <Divider sx={{ mb: 3, backgroundColor: mode === 'dark' ? '#333' : '#e0e0e0' }} />
//         <Typography
//           variant="subtitle1"
//           sx={{
//             fontWeight: '600',
//             color: mode === 'dark' ? '#aaa' : '#666',
//             mb: 2,
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1,
//           }}
//         >
//           <Box
//             sx={{
//               width: 8,
//               height: 8,
//               borderRadius: '50%',
//               backgroundColor: mode === 'dark' ? '#aaa' : '#666',
//             }}
//           />
//           Basic Optional Fields
//         </Typography>
//       </Box>

//       <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', mb: 4 }}>
//         <FormControlLabel
//           control={
//             <Checkbox
//               checked={includeWhatsapp}
//               onChange={(e) => setIncludeWhatsapp(e.target.checked)}
//               sx={{ color: '#102dff' }}
//             />
//           }
//           label="Include WhatsApp Number"
//         />
//         <FormControlLabel
//           control={
//             <Checkbox
//               checked={includePhone2}
//               onChange={(e) => setIncludePhone2(e.target.checked)}
//               sx={{ color: '#102dff' }}
//             />
//           }
//           label="Include Secondary Phone"
//         />
//         <FormControlLabel
//           control={
//             <Checkbox
//               checked={includeJobDesc}
//               onChange={(e) => setIncludeJobDesc(e.target.checked)}
//               sx={{ color: '#102dff' }}
//             />
//           }
//           label="Include Job Description"
//         />
//       </Box>

//       {/* Campaign Redirect Link */}
//       <Box sx={{ mb: 4 }}>
//         <TextField
//           fullWidth
//           label="Campaign Redirect Link"
//           variant="outlined"
//           size="small"
//           value={campaignRedirectLink}
//           onChange={(e) => setCampaignRedirectLink(e.target.value)}
//           placeholder="https://example.com/thank-you"
//           InputProps={{
//             startAdornment: (
//               <LinkIcon sx={{ mr: 1, color: mode === 'dark' ? '#aaa' : '#666' }} />
//             ),
//           }}
//           helperText="Optional: URL to redirect after lead creation"
//         />
//       </Box>

//       {/* Questions Section - Text Only (Answers will come from form) */}
//       <Box sx={{ mt: 2, mb: 3 }}>
//         <Divider sx={{ mb: 3, backgroundColor: mode === 'dark' ? '#333' : '#e0e0e0' }} />
//         <Typography
//           variant="subtitle1"
//           sx={{
//             fontWeight: '600',
//             color: mode === 'dark' ? '#aaa' : '#666',
//             mb: 2,
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1,
//           }}
//         >
//           <HelpOutlineIcon sx={{ fontSize: 20 }} />
//           Custom Questions - Text Only (Answers will come from form)
//         </Typography>
//       </Box>

//       <Grid container spacing={2} sx={{ mb: 4 }}>
//         {/* Question 1 - Text Only */}
//         <Grid item xs={12}>
//           <Accordion 
//             sx={{ 
//               backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f9f9f9',
//               boxShadow: 'none',
//               border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//             }}
//           >
//             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={includeQuestion1}
//                       onChange={(e) => setIncludeQuestion1(e.target.checked)}
//                       sx={{ color: '#102dff' }}
//                       onClick={(e) => e.stopPropagation()}
//                     />
//                   }
//                   label="Question 1"
//                   onClick={(e) => e.stopPropagation()}
//                 />
//                 {includeQuestion1 && (
//                   <Chip 
//                     label="Included" 
//                     size="small" 
//                     sx={{ 
//                       backgroundColor: '#102dff', 
//                       color: 'white',
//                       height: 20,
//                       fontSize: '10px',
//                     }} 
//                   />
//                 )}
//               </Box>
//             </AccordionSummary>
//             <AccordionDetails>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     label="Question 1 Text"
//                     variant="outlined"
//                     size="small"
//                     value={question1_text}
//                     onChange={(e) => setQuestion1_text(e.target.value)}
//                     disabled={!includeQuestion1}
//                     placeholder="e.g., What is your budget?"
//                     required={includeQuestion1}
//                     error={includeQuestion1 && !question1_text}
//                     helperText={includeQuestion1 && !question1_text ? "Question text is required" : ""}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="caption" color="text.secondary">
//                     ⓘ Answer will be provided by the customer in the form
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </AccordionDetails>
//           </Accordion>
//         </Grid>

//         {/* Question 2 - Text Only */}
//         <Grid item xs={12}>
//           <Accordion 
//             sx={{ 
//               backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f9f9f9',
//               boxShadow: 'none',
//               border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//             }}
//           >
//             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={includeQuestion2}
//                       onChange={(e) => setIncludeQuestion2(e.target.checked)}
//                       sx={{ color: '#102dff' }}
//                       onClick={(e) => e.stopPropagation()}
//                     />
//                   }
//                   label="Question 2"
//                   onClick={(e) => e.stopPropagation()}
//                 />
//                 {includeQuestion2 && (
//                   <Chip 
//                     label="Included" 
//                     size="small" 
//                     sx={{ 
//                       backgroundColor: '#102dff', 
//                       color: 'white',
//                       height: 20,
//                       fontSize: '10px',
//                     }} 
//                   />
//                 )}
//               </Box>
//             </AccordionSummary>
//             <AccordionDetails>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     label="Question 2 Text"
//                     variant="outlined"
//                     size="small"
//                     value={question2_text}
//                     onChange={(e) => setQuestion2_text(e.target.value)}
//                     disabled={!includeQuestion2}
//                     placeholder="e.g., When do you plan to buy?"
//                     required={includeQuestion2}
//                     error={includeQuestion2 && !question2_text}
//                     helperText={includeQuestion2 && !question2_text ? "Question text is required" : ""}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="caption" color="text.secondary">
//                     ⓘ Answer will be provided by the customer in the form
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </AccordionDetails>
//           </Accordion>
//         </Grid>

//         {/* Question 3 - Text Only */}
//         <Grid item xs={12}>
//           <Accordion 
//             sx={{ 
//               backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f9f9f9',
//               boxShadow: 'none',
//               border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//             }}
//           >
//             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={includeQuestion3}
//                       onChange={(e) => setIncludeQuestion3(e.target.checked)}
//                       sx={{ color: '#102dff' }}
//                       onClick={(e) => e.stopPropagation()}
//                     />
//                   }
//                   label="Question 3"
//                   onClick={(e) => e.stopPropagation()}
//                 />
//                 {includeQuestion3 && (
//                   <Chip 
//                     label="Included" 
//                     size="small" 
//                     sx={{ 
//                       backgroundColor: '#102dff', 
//                       color: 'white',
//                       height: 20,
//                       fontSize: '10px',
//                     }} 
//                   />
//                 )}
//               </Box>
//             </AccordionSummary>
//             <AccordionDetails>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     label="Question 3 Text"
//                     variant="outlined"
//                     size="small"
//                     value={question3_text}
//                     onChange={(e) => setQuestion3_text(e.target.value)}
//                     disabled={!includeQuestion3}
//                     placeholder="e.g., What property type?"
//                     required={includeQuestion3}
//                     error={includeQuestion3 && !question3_text}
//                     helperText={includeQuestion3 && !question3_text ? "Question text is required" : ""}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="caption" color="text.secondary">
//                     ⓘ Answer will be provided by the customer in the form
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </AccordionDetails>
//           </Accordion>
//         </Grid>

//         {/* Question 4 - Text Only */}
//         <Grid item xs={12}>
//           <Accordion 
//             sx={{ 
//               backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f9f9f9',
//               boxShadow: 'none',
//               border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//             }}
//           >
//             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={includeQuestion4}
//                       onChange={(e) => setIncludeQuestion4(e.target.checked)}
//                       sx={{ color: '#102dff' }}
//                       onClick={(e) => e.stopPropagation()}
//                     />
//                   }
//                   label="Question 4"
//                   onClick={(e) => e.stopPropagation()}
//                 />
//                 {includeQuestion4 && (
//                   <Chip 
//                     label="Included" 
//                     size="small" 
//                     sx={{ 
//                       backgroundColor: '#102dff', 
//                       color: 'white',
//                       height: 20,
//                       fontSize: '10px',
//                     }} 
//                   />
//                 )}
//               </Box>
//             </AccordionSummary>
//             <AccordionDetails>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     label="Question 4 Text"
//                     variant="outlined"
//                     size="small"
//                     value={question4_text}
//                     onChange={(e) => setQuestion4_text(e.target.value)}
//                     disabled={!includeQuestion4}
//                     placeholder="e.g., Preferred location?"
//                     required={includeQuestion4}
//                     error={includeQuestion4 && !question4_text}
//                     helperText={includeQuestion4 && !question4_text ? "Question text is required" : ""}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="caption" color="text.secondary">
//                     ⓘ Answer will be provided by the customer in the form
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </AccordionDetails>
//           </Accordion>
//         </Grid>

//         {/* Question 5 - Text Only */}
//         <Grid item xs={12}>
//           <Accordion 
//             sx={{ 
//               backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f9f9f9',
//               boxShadow: 'none',
//               border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//             }}
//           >
//             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={includeQuestion5}
//                       onChange={(e) => setIncludeQuestion5(e.target.checked)}
//                       sx={{ color: '#102dff' }}
//                       onClick={(e) => e.stopPropagation()}
//                     />
//                   }
//                   label="Question 5"
//                   onClick={(e) => e.stopPropagation()}
//                 />
//                 {includeQuestion5 && (
//                   <Chip 
//                     label="Included" 
//                     size="small" 
//                     sx={{ 
//                       backgroundColor: '#102dff', 
//                       color: 'white',
//                       height: 20,
//                       fontSize: '10px',
//                     }} 
//                   />
//                 )}
//               </Box>
//             </AccordionSummary>
//             <AccordionDetails>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     label="Question 5 Text"
//                     variant="outlined"
//                     size="small"
//                     value={question5_text}
//                     onChange={(e) => setQuestion5_text(e.target.value)}
//                     disabled={!includeQuestion5}
//                     placeholder="e.g., How did you hear about us?"
//                     required={includeQuestion5}
//                     error={includeQuestion5 && !question5_text}
//                     helperText={includeQuestion5 && !question5_text ? "Question text is required" : ""}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="caption" color="text.secondary">
//                     ⓘ Answer will be provided by the customer in the form
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </AccordionDetails>
//           </Accordion>
//         </Grid>
//       </Grid>

//       {/* Generate URL Button */}
//       <Box sx={{ mt: 4 }}>
//         <Button
//           variant="contained"
//           onClick={generateUrl}
//           fullWidth
//           size="large"
//           sx={{
//             backgroundColor: '#102dff',
//             color: 'white',
//             py: 1.5,
//             fontSize: '1rem',
//             fontWeight: '600',
//             borderRadius: 2,
//             '&:hover': {
//               backgroundColor: '#0a25d9',
//             },
//           }}
//           startIcon={<CreateNewFolderIcon />}
//         >
//           Generate Webhook URL
//         </Button>
//       </Box>

//       {/* Generated URL */}
//       {!generate && urlcreated && (
//         <Paper
//           elevation={0}
//           sx={{
//             mt: 3,
//             p: 2,
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f5f5f5',
//             borderRadius: 2,
//             border: `2px solid ${copied ? '#4caf50' : '#102dff'}`,
//             position: 'relative',
//             transition: 'border-color 0.3s',
//           }}
//         >
//           <Typography
//             variant="body2"
//             sx={{
//               wordBreak: 'break-word',
//               color: mode === 'dark' ? '#90caf9' : '#102dff',
//               fontFamily: 'monospace',
//               fontSize: '14px',
//               pr: 5,
//             }}
//           >
//             {urlcreated}
//           </Typography>

//           <Tooltip title={copied ? 'Copied!' : 'Copy URL'}>
//             <IconButton
//               onClick={() => {
//                 navigator.clipboard.writeText(urlcreated);
//                 handleCopy();
//               }}
//               sx={{
//                 position: 'absolute',
//                 top: 8,
//                 right: 8,
//                 backgroundColor: copied ? '#4caf50' : '#102dff',
//                 color: 'white',
//                 '&:hover': {
//                   backgroundColor: copied ? '#45a049' : '#0a25d9',
//                 },
//               }}
//             >
//               {copied ? <CheckCircleIcon /> : <ContentCopyIcon />}
//             </IconButton>
//           </Tooltip>
//         </Paper>
//       )}
//     </Paper>
//   );
// };
























// 20-5-2026
import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { GetAll_stage_Data } from '../../Redux/Actions/Stage_Action';
import { GetAllchannalData } from '../../Redux/Actions/ChannalActions';
import { GetCommunicationwayData } from '../../Redux/Actions/CommunicationWay_Action';
import { GetAllCampainData } from '../../Redux/Actions/Campaign_Actions';
import { GetallProjectsdata } from '../../Redux/Actions/Projects_Action';
import { Get_All_Sales_Action } from '../../Redux/Actions/SalesAction';
import { Notify } from '../../Utility/Notify';
import { db_url } from '../../Api/BaseUrl';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';
import { LeedintegrationKeys } from './LeedintegrationKeys';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconWebhook  = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 16.98h-5.99c-1.66 0-2.98-1.36-2.98-3.04 0-1.67 1.32-3.04 2.98-3.04h5.99"/><path d="M6 8h6.01C13.67 8 15 9.36 15 11.04c0 1.67-1.33 3.04-3 3.04H6"/><circle cx="18" cy="17" r="3"/><circle cx="6" cy="7" r="3"/></svg>;
const IconChevron  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>;
const IconSearch   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconClose    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconCopy     = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IconCheck    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IconLink     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>;
const IconSliders  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/></svg>;
const IconGenerate = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>;
const IconQuestion = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;

/* ─── Single Select ──────────────────────────────────────────────────────── */
const SingleSelect = ({ label, options, value, onChange, isDark, getLabel, getId, required }) => {
  const [open, setOpen]       = useState(false);
  const [search, setSearch]   = useState('');
  const [dropPos, setDropPos] = useState({ top: 0, left: 0, width: 0 });
  const triggerRef = useRef(null);
  const ref        = useRef(null);
  const selected   = options.find(o => getId(o) === value);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const handleOpen = () => {
    if (!open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const above = spaceBelow < 240 && rect.top > spaceBelow;
      setDropPos({ left: rect.left, width: rect.width, top: above ? rect.top - 244 : rect.bottom + 4 });
    }
    setOpen(o => !o);
    setSearch('');
  };

  const filtered = options.filter(o => getLabel(o).toLowerCase().includes(search.toLowerCase()));
  const hasError = required && !value;

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div ref={triggerRef} onClick={handleOpen} style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', fontSize: '13px', border: `1.5px solid ${hasError ? '#ef4444' : open ? '#2563eb' : (isDark ? '#2d3248' : '#e2e8f0')}`, backgroundColor: isDark ? '#151827' : '#f8fafc', color: selected ? (isDark ? '#f1f5f9' : '#0f172a') : (isDark ? '#6b7280' : '#94a3b8'), fontFamily: "'DM Sans',sans-serif", cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxSizing: 'border-box', userSelect: 'none', minHeight: '44px', boxShadow: open ? '0 0 0 3px rgba(37,99,235,0.12)' : (hasError ? '0 0 0 3px rgba(239,68,68,0.1)' : 'none'), transition: 'all 0.15s' }}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, marginRight: 8, fontSize: '13px' }}>{selected ? getLabel(selected) : label}</span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
          {value && <span onClick={(e) => { e.stopPropagation(); onChange(''); }} style={{ display: 'flex', color: isDark ? '#6b7280' : '#94a3b8', padding: 2 }}><IconClose /></span>}
          <span style={{ display: 'flex', color: isDark ? '#6b7280' : '#94a3b8', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}><IconChevron /></span>
        </span>
      </div>
      {open && (
        <div style={{ position: 'fixed', top: dropPos.top, left: dropPos.left, width: dropPos.width, zIndex: 999999, backgroundColor: isDark ? '#1e2132' : '#fff', border: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`, borderRadius: '12px', overflow: 'hidden', boxShadow: isDark ? '0 16px 48px rgba(0,0,0,0.55)' : '0 8px 32px rgba(0,0,0,0.12)', animation: 'ss-open 0.14s ease both' }}>
          <div style={{ position: 'relative', borderBottom: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}` }}>
            <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: isDark ? '#6b7280' : '#94a3b8', display: 'flex', pointerEvents: 'none' }}><IconSearch /></span>
            <input autoFocus value={search} onChange={e => setSearch(e.target.value)} placeholder="Search…" style={{ width: '100%', padding: '10px 12px 10px 32px', fontSize: '13px', border: 'none', outline: 'none', backgroundColor: isDark ? '#151827' : '#f8fafc', color: isDark ? '#e5e7eb' : '#1f2937', fontFamily: "'DM Sans',sans-serif", boxSizing: 'border-box' }} />
          </div>
          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {filtered.length === 0
              ? <div style={{ padding: '14px', fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', textAlign: 'center' }}>No results</div>
              : filtered.map(o => {
                const id = getId(o); const isSel = value === id;
                return (
                  <div key={id} onClick={() => { onChange(id); setOpen(false); }} style={{ padding: '10px 14px', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10, backgroundColor: isSel ? (isDark ? 'rgba(37,99,235,0.12)' : 'rgba(37,99,235,0.06)') : 'transparent', fontFamily: "'DM Sans',sans-serif", borderLeft: isSel ? '3px solid #1d4ed8' : '3px solid transparent' }}
                    onMouseEnter={e => { if (!isSel) e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)'; }}
                    onMouseLeave={e => { if (!isSel) e.currentTarget.style.backgroundColor = 'transparent'; }}
                  >
                    {isSel && <span style={{ color: '#1d4ed8', display: 'flex', flexShrink: 0 }}><IconCheck /></span>}
                    <span style={{ color: isDark ? '#e5e7eb' : '#1f2937' }}>{getLabel(o)}</span>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
};

/* ─── Checkbox Row ───────────────────────────────────────────────────────── */
const CheckRow = ({ checked, onChange, label, isDark }) => (
  <div onClick={() => onChange(!checked)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', borderRadius: '10px', border: `1.5px solid ${checked ? '#1d4ed8' : (isDark ? '#2d3248' : '#e2e8f0')}`, backgroundColor: checked ? (isDark ? 'rgba(37,99,235,0.1)' : 'rgba(37,99,235,0.05)') : 'transparent', cursor: 'pointer', transition: 'all 0.15s', userSelect: 'none' }}>
    <div style={{ width: 18, height: 18, borderRadius: 5, border: `1.5px solid ${checked ? '#1d4ed8' : (isDark ? '#4b5563' : '#d1d5db')}`, backgroundColor: checked ? '#1d4ed8' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'all 0.15s' }}>
      {checked && <span style={{ color: '#fff', display: 'flex' }}><IconCheck /></span>}
    </div>
    <span style={{ fontSize: '13px', fontWeight: checked ? 600 : 400, color: isDark ? (checked ? '#93c5fd' : '#9ca3af') : (checked ? '#1d4ed8' : '#374151'), fontFamily: "'DM Sans',sans-serif" }}>{label}</span>
  </div>
);

/* ─── Collapsible Section Header ─────────────────────────────────────────── */
const CollapseHeader = ({ open, onToggle, icon, title, count, countColor, isDark }) => (
  <div onClick={onToggle} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '13px 16px', borderRadius: open ? '10px 10px 0 0' : '10px', border: `1.5px solid ${count > 0 ? countColor : (isDark ? '#2d3248' : '#e2e8f0')}`, backgroundColor: count > 0 ? (isDark ? `rgba(0,0,0,0)` : `rgba(0,0,0,0)`) : 'transparent', background: count > 0 ? (isDark ? `${countColor}18` : `${countColor}0d`) : (isDark ? '#151827' : '#f8fafc'), cursor: 'pointer', userSelect: 'none', transition: 'all 0.15s' }}>
    <span style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: 600, color: count > 0 ? countColor : (isDark ? '#9ca3af' : '#64748b'), fontFamily: "'DM Sans',sans-serif" }}>
      {icon} {title}
    </span>
    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {count > 0 && <span style={{ padding: '2px 9px', borderRadius: '999px', background: countColor, color: '#fff', fontSize: '11px', fontWeight: 700 }}>{count} active</span>}
      <span style={{ display: 'flex', color: isDark ? '#6b7280' : '#94a3b8', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.22s' }}><IconChevron /></span>
    </span>
  </div>
);

/* ─── Main Component ─────────────────────────────────────────────────────── */
export const IntegrationWebhook = () => {
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const dispatch     = useDispatch();
  const sidebarWidth = useSidebarWidth();

  /* ── Required fields ── */
  const [project,          setProject]          = useState('');
  const [salesdata,        setSalesdata]         = useState('');
  const [stage,            setStage]             = useState('');
  const [channal,          setChannal]           = useState('');
  const [communicationway, setCommunicationway]  = useState('');
  const [campaignid,       setCampaignid]        = useState('');

  /* ── Optional fields — inline collapse ── */
  const [optOpen,              setOptOpen]              = useState(false);
  const [includeWhatsapp,      setIncludeWhatsapp]      = useState(false);
  const [includePhone2,        setIncludePhone2]        = useState(false);
  const [includeJobDesc,       setIncludeJobDesc]       = useState(false);
  const [campaignRedirectLink, setCampaignRedirectLink] = useState('');

  /* ── Questions — inline collapse ── */
  const [qOpen,             setQOpen]             = useState(false);
  const [questionsIncluded, setQuestionsIncluded] = useState([false, false, false, false, false]);
  const [questionsText,     setQuestionsText]     = useState(['', '', '', '', '']);

  const questionPlaceholders = [
    'e.g., What is your budget?',
    'e.g., When do you plan to buy?',
    'e.g., What property type?',
    'e.g., Preferred location?',
    'e.g., How did you hear about us?',
  ];

  /* ── URL output ── */
  const [urlcreated, setUrlcreated] = useState('');
  const [generated,  setGenerated]  = useState(false);
  const [copied,     setCopied]     = useState(false);

  /* ── Redux ── */
  useEffect(() => {
    dispatch(GetAll_stage_Data());
    dispatch(GetAllchannalData());
    dispatch(GetCommunicationwayData());
    dispatch(GetAllCampainData());
    dispatch(GetallProjectsdata());
    dispatch(Get_All_Sales_Action());
  }, [dispatch]);

  const resProjects = useSelector(s => s.AllProjects.Projects);
  const ressales    = useSelector(s => s.AllSales.sales);
  const resStages   = useSelector(s => s.Allstages.stage);
  const resChannal  = useSelector(s => s.AllChannalRoot.channal);
  const resCW       = useSelector(s => s.AllCommunicationway.communicationway);
  const resCampaign = useSelector(s => s.AllCampaign.campaign);

  const Allprojects  = Array.isArray(resProjects?.data)  ? resProjects.data  : [];
  const allStages    = Array.isArray(resStages?.data)    ? resStages.data    : [];
  const allChannal   = Array.isArray(resChannal?.data)   ? resChannal.data   : [];
  const allCW        = Array.isArray(resCW?.data)        ? resCW.data        : [];
  const allCampaigns = Array.isArray(resCampaign?.data)  ? resCampaign.data  : [];

  const EXCLUDE = ['Default', 'Default M', 'Default T', 'Default S', 'Deveolper', 'Developer', 'Dev'];
  const salesData = (Array.isArray(ressales?.data) ? ressales.data : [])
    .filter(s => !EXCLUDE.includes(s.name))
    .sort((a, b) => a.name === 'No Sales' ? -1 : b.name === 'No Sales' ? 1 : 0);

  let user = null;
  try { user = JSON.parse(localStorage.getItem('user')); } catch {}

  const optCount = [includeWhatsapp, includePhone2, includeJobDesc, !!campaignRedirectLink].filter(Boolean).length;
  const qCount   = questionsIncluded.filter(Boolean).length;

  /* ── Generate URL ── */
  const generateUrl = () => {
    if (!project)          return Notify('error', 'Project is required',           'error');
    if (!salesdata)        return Notify('error', 'Sales is required',             'error');
    if (!channal)          return Notify('error', 'Channel is required',           'error');
    if (!communicationway) return Notify('error', 'Communication way is required', 'error');
    if (!stage)            return Notify('error', 'Stage is required',             'error');
    if (!campaignid)       return Notify('error', 'Campaign is required',          'error');
    for (let i = 0; i < 5; i++) {
      if (questionsIncluded[i] && !questionsText[i].trim())
        return Notify('error', `Question ${i + 1} text is required`, 'error');
    }
    const params = {
      addedby: user?.data?._id || '', stage, Channal: channal, project, salesdata,
      Communicationway: communicationway, campaignid,
      includePhone2:    includePhone2   ? 'true' : 'false',
      includeWhatsapp:  includeWhatsapp ? 'true' : 'false',
      includeJobDesc:   includeJobDesc  ? 'true' : 'false',
      ...(campaignRedirectLink && { campaignRedirectLink }),
    };
    for (let i = 0; i < 5; i++) {
      params[`includeQuestion${i + 1}`] = questionsIncluded[i] ? 'true' : 'false';
      if (questionsIncluded[i] && questionsText[i]) params[`question${i + 1}_text`] = questionsText[i];
    }
    setUrlcreated(`${db_url}api/v1/users/create-with-params?${new URLSearchParams(params).toString()}`);
    setGenerated(true);
    setCopied(false);
  };

  const labelSt   = { display: 'block', fontSize: '11px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: isDark ? '#6b7280' : '#64748b', marginBottom: '7px', fontFamily: "'DM Sans',sans-serif" };
  const fieldWrap = { marginBottom: '18px' };
  const divider   = { height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '12px 0' };

  return (
    <>
      <style>{`
        @keyframes ss-open    { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:none; } }
        @keyframes fadeInUp   { from { opacity:0; transform:translateY(4px);  } to { opacity:1; transform:none; } }
        @keyframes collapseIn { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:none; } }
      `}</style>

      <div style={{ position: 'fixed', top: '50px', left: sidebarWidth, right: 0, bottom: 0, transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)', overflowY: 'auto', overflowX: 'hidden', display: 'flex', flexDirection: 'column', fontFamily: "'DM Sans','Segoe UI',sans-serif" }}>

        {/* Breadcrumb */}
        <section style={{ padding: '16px 20px 0', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
            <Link to="/AllLeadsForAdmin" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>Home</Link>
            <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
            <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Integration Webhook</span>
          </div>
        </section>

        {/* Main */}
        <section style={{ flex: 1, padding: '20px 20px 48px', display: 'flex', flexDirection: 'column' }}>

          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: isDark ? '#6b7280' : '#94a3b8', marginBottom: '4px' }}>INTEGRATIONS</div>
            <h1 style={{ fontSize: '24px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0f172a', margin: '0 0 4px', letterSpacing: '-0.4px' }}>WEBHOOK GENERATOR</h1>
            <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#64748b', margin: 0 }}>Configure required fields, then expand optional settings below.</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', alignItems: 'start' }}>

            {/* ══ LEFT ══ */}
            <div style={{ backgroundColor: isDark ? '#1e2132' : '#fff', borderRadius: '16px', padding: '28px', border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0', boxShadow: isDark ? '0 8px 32px rgba(0,0,0,0.35)' : '0 2px 16px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                <div style={{ width: 38, height: 38, borderRadius: '10px', background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', flexShrink: 0 }}><IconWebhook /></div>
                <div>
                  <div style={{ fontSize: '15px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0d1b3e' }}>Required Fields</div>
                  <div style={{ fontSize: '12px', color: isDark ? '#6b7280' : '#94a3b8' }}>All 6 fields are mandatory</div>
                </div>
              </div>
              <div style={fieldWrap}><label style={labelSt}>Project *</label><SingleSelect label="Choose project…" options={Allprojects} value={project} onChange={setProject} isDark={isDark} getLabel={o => o.name || ''} getId={o => o._id} required /></div>
              <div style={fieldWrap}><label style={labelSt}>Sales *</label><SingleSelect label="Choose sales…" options={salesData} value={salesdata} onChange={setSalesdata} isDark={isDark} getLabel={o => `${o.name}${o.userlog?.role ? ` — ${o.userlog.role}` : ''}`} getId={o => o._id} required /></div>
              <div style={fieldWrap}><label style={labelSt}>Stage *</label><SingleSelect label="Choose stage…" options={allStages} value={stage} onChange={setStage} isDark={isDark} getLabel={o => o.name || ''} getId={o => o._id} required /></div>
              <div style={fieldWrap}><label style={labelSt}>Channel *</label><SingleSelect label="Choose channel…" options={allChannal} value={channal} onChange={setChannal} isDark={isDark} getLabel={o => o.name || ''} getId={o => o._id} required /></div>
              <div style={fieldWrap}><label style={labelSt}>Communication Way *</label><SingleSelect label="Choose communication way…" options={allCW} value={communicationway} onChange={setCommunicationway} isDark={isDark} getLabel={o => o.name || ''} getId={o => o._id} required /></div>
              <div style={{ marginBottom: 0 }}><label style={labelSt}>Campaign *</label><SingleSelect label="Choose campaign…" options={allCampaigns} value={campaignid} onChange={setCampaignid} isDark={isDark} getLabel={o => o.CampainName || ''} getId={o => o._id} required /></div>
            </div>

            {/* ══ RIGHT ══ */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>

              {/* ── Optional Fields — inline collapse ── */}
              <div>
                <CollapseHeader open={optOpen} onToggle={() => setOptOpen(o => !o)} icon={<IconSliders />} title="Optional Fields" count={optCount} countColor="#1d4ed8" isDark={isDark} />
                {optOpen && (
                  <div style={{ border: `1.5px solid ${optCount > 0 ? '#1d4ed8' : (isDark ? '#2d3248' : '#e2e8f0')}`, borderTop: 'none', borderRadius: '0 0 10px 10px', padding: '16px', backgroundColor: isDark ? '#151827' : '#f8fafc', display: 'flex', flexDirection: 'column', gap: '10px', animation: 'collapseIn 0.18s ease both' }}>
                    <CheckRow checked={includeWhatsapp} onChange={setIncludeWhatsapp} label="Include WhatsApp Number" isDark={isDark} />
                    <CheckRow checked={includePhone2}   onChange={setIncludePhone2}   label="Include Secondary Phone"  isDark={isDark} />
                    <CheckRow checked={includeJobDesc}  onChange={setIncludeJobDesc}  label="Include Job Description"  isDark={isDark} />
                    <div style={divider} />
                    <div>
                      <label style={labelSt}>Campaign Redirect Link</label>
                      <div style={{ position: 'relative' }}>
                        <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: isDark ? '#6b7280' : '#94a3b8', display: 'flex', pointerEvents: 'none' }}><IconLink /></span>
                        <input type="url" value={campaignRedirectLink} onChange={e => setCampaignRedirectLink(e.target.value)} placeholder="https://example.com/thank-you"
                          style={{ width: '100%', padding: '11px 14px 11px 34px', borderRadius: '10px', fontSize: '13px', border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`, backgroundColor: isDark ? '#1e2132' : '#fff', color: isDark ? '#f1f5f9' : '#0f172a', fontFamily: "'DM Sans',sans-serif", outline: 'none', boxSizing: 'border-box' }}
                          onFocus={e => { e.target.style.borderColor = '#2563eb'; e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.12)'; }}
                          onBlur={e  => { e.target.style.borderColor = isDark ? '#2d3248' : '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
                        />
                      </div>
                      <p style={{ fontSize: '11px', color: isDark ? '#4b5563' : '#94a3b8', margin: '5px 0 0', fontFamily: "'DM Sans',sans-serif" }}>Optional: URL to redirect after lead creation</p>
                    </div>
                  </div>
                )}
              </div>

              {/* ── Custom Questions — inline collapse ── */}
              <div>
                <CollapseHeader open={qOpen} onToggle={() => setQOpen(o => !o)} icon={<IconQuestion />} title="Custom Questions" count={qCount} countColor="#7c3aed" isDark={isDark} />
                {qOpen && (
                  <div style={{ border: `1.5px solid ${qCount > 0 ? '#7c3aed' : (isDark ? '#2d3248' : '#e2e8f0')}`, borderTop: 'none', borderRadius: '0 0 10px 10px', padding: '14px', backgroundColor: isDark ? '#151827' : '#f8fafc', display: 'flex', flexDirection: 'column', gap: '10px', animation: 'collapseIn 0.18s ease both' }}>
                    <p style={{ fontSize: '11px', color: isDark ? '#6b7280' : '#94a3b8', margin: '0 0 2px', fontFamily: "'DM Sans',sans-serif" }}>Answers will be provided by the customer in the form.</p>
                    {questionPlaceholders.map((placeholder, i) => (
                      <div key={i} style={{ borderRadius: '10px', border: `1.5px solid ${questionsIncluded[i] ? '#7c3aed' : (isDark ? '#2d3248' : '#e2e8f0')}`, overflow: 'hidden', transition: 'border-color 0.15s' }}>
                        <div onClick={() => setQuestionsIncluded(prev => prev.map((v, idx) => idx === i ? !v : v))} style={{ padding: '10px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', backgroundColor: questionsIncluded[i] ? (isDark ? 'rgba(124,58,237,0.1)' : 'rgba(124,58,237,0.05)') : 'transparent', userSelect: 'none' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{ width: 18, height: 18, borderRadius: 5, border: `1.5px solid ${questionsIncluded[i] ? '#7c3aed' : (isDark ? '#4b5563' : '#d1d5db')}`, backgroundColor: questionsIncluded[i] ? '#7c3aed' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'all 0.15s' }}>
                              {questionsIncluded[i] && <span style={{ color: '#fff', display: 'flex' }}><IconCheck /></span>}
                            </div>
                            <span style={{ fontSize: '13px', fontWeight: 600, color: isDark ? (questionsIncluded[i] ? '#c4b5fd' : '#9ca3af') : (questionsIncluded[i] ? '#7c3aed' : '#374151'), fontFamily: "'DM Sans',sans-serif" }}>Question {i + 1}</span>
                            {questionsIncluded[i] && questionsText[i] && (
                              <span style={{ fontSize: '11px', color: isDark ? '#6b7280' : '#94a3b8', fontStyle: 'italic', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '120px', fontFamily: "'DM Sans',sans-serif" }}>"{questionsText[i]}"</span>
                            )}
                          </div>
                          {questionsIncluded[i] && <span style={{ fontSize: '10px', fontWeight: 700, padding: '2px 8px', borderRadius: '999px', background: '#7c3aed', color: '#fff', flexShrink: 0 }}>Included</span>}
                        </div>
                        {questionsIncluded[i] && (
                          <div style={{ padding: '10px 14px', borderTop: `1px solid ${isDark ? '#2a2f45' : '#e8eaf0'}`, backgroundColor: isDark ? '#1e2132' : '#fff' }}>
                            <input type="text" value={questionsText[i]} onChange={e => { const v = e.target.value; setQuestionsText(prev => prev.map((x, idx) => idx === i ? v : x)); }} placeholder={placeholder}
                              style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', fontSize: '13px', border: `1.5px solid ${!questionsText[i] ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0')}`, backgroundColor: isDark ? '#151827' : '#f8fafc', color: isDark ? '#f1f5f9' : '#0f172a', fontFamily: "'DM Sans',sans-serif", outline: 'none', boxSizing: 'border-box' }}
                              onFocus={e => { e.target.style.borderColor = '#7c3aed'; e.target.style.boxShadow = '0 0 0 3px rgba(124,58,237,0.12)'; }}
                              onBlur={e  => { e.target.style.borderColor = !questionsText[i] ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0'); e.target.style.boxShadow = 'none'; }}
                            />
                            {!questionsText[i] && <p style={{ fontSize: '11px', color: '#ef4444', margin: '4px 0 0', fontFamily: "'DM Sans',sans-serif" }}>Question text is required</p>}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Integration Keys */}
              <LeedintegrationKeys />

              {/* Active summary chips */}
              {(optCount > 0 || qCount > 0) && (
                <div style={{ backgroundColor: isDark ? '#151827' : '#f8fafc', borderRadius: '12px', padding: '12px 14px', border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0', display: 'flex', flexWrap: 'wrap', gap: '7px', animation: 'fadeInUp 0.2s ease both' }}>
                  {includeWhatsapp       && <span style={{ padding: '4px 10px', borderRadius: '8px', fontSize: '11px', fontWeight: 600, background: isDark ? 'rgba(37,99,235,0.15)' : '#eef1fb', color: isDark ? '#93c5fd' : '#1d4ed8' }}>WhatsApp ✓</span>}
                  {includePhone2         && <span style={{ padding: '4px 10px', borderRadius: '8px', fontSize: '11px', fontWeight: 600, background: isDark ? 'rgba(37,99,235,0.15)' : '#eef1fb', color: isDark ? '#93c5fd' : '#1d4ed8' }}>Phone 2 ✓</span>}
                  {includeJobDesc        && <span style={{ padding: '4px 10px', borderRadius: '8px', fontSize: '11px', fontWeight: 600, background: isDark ? 'rgba(37,99,235,0.15)' : '#eef1fb', color: isDark ? '#93c5fd' : '#1d4ed8' }}>Job Desc ✓</span>}
                  {!!campaignRedirectLink && <span style={{ padding: '4px 10px', borderRadius: '8px', fontSize: '11px', fontWeight: 600, background: isDark ? 'rgba(37,99,235,0.15)' : '#eef1fb', color: isDark ? '#93c5fd' : '#1d4ed8' }}>Redirect URL ✓</span>}
                  {questionsIncluded.map((inc, i) => inc && (
                    <span key={i} style={{ padding: '4px 10px', borderRadius: '8px', fontSize: '11px', fontWeight: 600, background: isDark ? 'rgba(124,58,237,0.15)' : '#f3eeff', color: isDark ? '#c4b5fd' : '#7c3aed' }}>Q{i + 1} ✓</span>
                  ))}
                </div>
              )}

              {/* Generate button */}
              <button onClick={generateUrl} style={{ width: '100%', padding: '15px', borderRadius: '12px', border: 'none', background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)', color: '#fff', fontSize: '14px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)', fontFamily: "'DM Sans',sans-serif" }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)'; }}>
                <IconGenerate /> Generate Webhook URL
              </button>

              {/* Generated URL output */}
              {generated && urlcreated && (
                <div style={{ backgroundColor: isDark ? '#1e2132' : '#fff', borderRadius: '14px', border: `2px solid ${copied ? '#16a34a' : '#1d4ed8'}`, padding: '18px', boxShadow: isDark ? '0 4px 20px rgba(0,0,0,0.3)' : '0 2px 12px rgba(0,0,0,0.06)', transition: 'border-color 0.3s', animation: 'fadeInUp 0.2s ease both' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', marginBottom: '12px' }}>
                    <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: isDark ? '#6b7280' : '#94a3b8' }}>Generated URL</div>
                    <button onClick={() => { navigator.clipboard.writeText(urlcreated); setCopied(true); setTimeout(() => setCopied(false), 2000); }} style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '6px 12px', borderRadius: '8px', border: 'none', background: copied ? '#16a34a' : '#1d4ed8', color: '#fff', fontSize: '12px', fontWeight: 700, cursor: 'pointer', fontFamily: "'DM Sans',sans-serif", flexShrink: 0, transition: 'background 0.2s' }}>
                      {copied ? <><IconCheck /> Copied!</> : <><IconCopy /> Copy</>}
                    </button>
                  </div>
                  <div style={{ fontSize: '12px', fontFamily: 'monospace', color: isDark ? '#7da4ff' : '#1d4ed8', wordBreak: 'break-all', lineHeight: 1.7, backgroundColor: isDark ? '#151827' : '#f0f4ff', padding: '12px', borderRadius: '8px' }}>
                    {urlcreated}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        <footer style={{ flexShrink: 0, padding: '14px 20px', borderTop: `1px solid ${isDark ? '#2a2f45' : '#e8eaf0'}`, fontSize: '12px', color: isDark ? '#4b5563' : '#9ca3af', fontFamily: "'DM Sans', sans-serif" }}>
          <span>© 2026 Realatix CRM. Smart CRM that connects customers, data, and sales in one safe place.</span>
        </footer>
      </div>
    </>
  );
};